import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import InvoiceDetailsContent from './InvoiceDetailsContent';
import InvoiceDetailsPopupStyles from '../../../styles/purchaseInvoices/invoiceManagement/InvoiceDetailsPopupStyles';

const InvoiceDetailsPopup = ({
  open,
  onClose,
  invoice,
  onSaveNotes,
  onApproveInvoice,
  onRejectInvoice,
  approvalPackageData,
  accountingFirm,
  fileAsBase64,
  isLoadingFile,
  initiateApproval,
  allocationKeyModalOpen,
  setAllocationKeyModalOpen,
  allocationKeys,
  isLoadingAllocationKeys,
  allocationKeysError,
  currentInvoiceYear,
  completeApprovalWithAllocationKey,
  updateInvoiceOptimistically,
  getAccountantDisplayName,
  accountantNamesCache
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        sx: InvoiceDetailsPopupStyles.paperProps
      }}
    >
      <DialogTitle sx={InvoiceDetailsPopupStyles.dialogTitle(theme)}>
        <Typography variant="h6" fontWeight="bold">
          {invoice
            ? `חשבונית ${invoice.booknum || invoice.id}${invoice.supplierName ? ` - ${invoice.supplierName}` : ''}`
            : 'פרטי חשבונית'}
        </Typography>
        <IconButton onClick={onClose} edge="end">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ ...InvoiceDetailsPopupStyles.dialogContent, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <InvoiceDetailsContent
          open={open}
          invoice={invoice}
          onSaveNotes={onSaveNotes}
          onApproveInvoice={onApproveInvoice}
          onRejectInvoice={onRejectInvoice}
          approvalPackageData={approvalPackageData}
          accountingFirm={accountingFirm}
          fileAsBase64={fileAsBase64}
          isLoadingFile={isLoadingFile}
          initiateApproval={initiateApproval}
          allocationKeyModalOpen={allocationKeyModalOpen}
          setAllocationKeyModalOpen={setAllocationKeyModalOpen}
          allocationKeys={allocationKeys}
          isLoadingAllocationKeys={isLoadingAllocationKeys}
          allocationKeysError={allocationKeysError}
          currentInvoiceYear={currentInvoiceYear}
          completeApprovalWithAllocationKey={completeApprovalWithAllocationKey}
          updateInvoiceOptimistically={updateInvoiceOptimistically}
          getAccountantDisplayName={getAccountantDisplayName}
          accountantNamesCache={accountantNamesCache}
        />
      </DialogContent>

      <DialogActions sx={InvoiceDetailsPopupStyles.dialogActions(theme)}>
        <Button onClick={onClose} variant="outlined">
          סגור
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvoiceDetailsPopup;
